import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from 'state/store';

export type UserPreferencesState = {
  marketingPreferences: {
    email: boolean;
    telephone: boolean;
    text: boolean;
    post: boolean;
  };
  meterReadPreferences: {
    electric: string | null;
    gas: string | null;
  };
};

export const initialState: UserPreferencesState = {
  marketingPreferences: {
    email: false,
    telephone: false,
    text: false,
    post: false
  },
  meterReadPreferences: {
    electric: null,
    gas: null
  }
};

export const slice = createSlice({
  name: 'userPreferences',
  initialState,
  reducers: {
    setInitialState: (state) => {
      state.marketingPreferences = initialState.marketingPreferences;
    },
    setMarketingPreferences: (state, { payload }) => {
      state.marketingPreferences = {
        ...state.marketingPreferences,
        ...payload
      };
    },
    setMeterReadPreferences: (state, { payload }) => {
      const { fuel, value } = payload;
      state.meterReadPreferences[fuel] = value;
    }
  }
});

export const {
  setMeterReadPreferences,
  setMarketingPreferences,
  setInitialState
} = slice.actions;

export const selectSlice = (state: RootState) => state[slice.name];
export const selectMarketingPreferences = (state: RootState) =>
  selectSlice(state).marketingPreferences;
export const selectMeterReadPreferences = (state: RootState) =>
  selectSlice(state).meterReadPreferences;

export default slice.reducer;
